<template>
  <hi-page style="align-items:flex-start">
    <!--    //// send bulk////-->
    <v-card class="mx-auto" max-width="344" color="#fefefe">
      <v-card-text>
        <p class="display-1 text--primary">
          Test sendBulkMessages
        </p>
        <div>
          <v-text-field
            v-model="smsNumber"
            placeholder="Number"
            dense
          ></v-text-field>
          <v-text-field
            v-model="smsNumber2"
            placeholder="Number2"
            dense
          ></v-text-field>
          <v-text-field
            v-model="smsNumber3"
            placeholder="Number3"
            dense
          ></v-text-field>
          <v-checkbox v-model="alphaSender" label="AlphaSender"></v-checkbox>
          <v-textarea v-model="smsMessage" hint="Message"></v-textarea>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="deep-purple accent-4" @click="sendSmsBulk">
          Send
        </v-btn>
      </v-card-actions>
    </v-card>
    <!--    //// send message////-->
    <v-card class="mx-auto" max-width="344" color="#fefefe">
      <v-card-text>
        <p class="display-1 text--primary">
          Test sendMessage
        </p>
        <div>
          <v-text-field
            v-model="smsNumber"
            placeholder="Number"
            dense
          ></v-text-field>
          <v-checkbox v-model="alphaSender" label="AlphaSender"></v-checkbox>
          <v-textarea v-model="smsMessage" hint="Message"></v-textarea>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="deep-purple accent-4" @click="sendSms">
          Send
        </v-btn>
      </v-card-actions>
    </v-card>
    <!--    //// schedule ////////-->

    <v-card class="mx-auto" max-width="344" color="#fefefe">
      <v-card-text>
        <p class="display-1 text--primary">
          Test scheduleSms
        </p>
        <div>
          <v-text-field
            v-model="smsNumber"
            placeholder="Number"
            dense
          ></v-text-field>
          <v-text-field
            v-model="smsTime"
            placeholder="How Many Seconds After?"
            dense
          ></v-text-field>
          <v-textarea v-model="smsMessage" hint="Message"></v-textarea>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="deep-purple accent-4" @click="scheduleSms">
          Schedule
        </v-btn>
      </v-card-actions>
    </v-card>
    <!--    //// group ////////-->

    <v-card class="mx-auto" max-width="344" color="#fefefe">
      <v-card-text>
        <p class="display-1 text--primary">
          Test GroupMessage
        </p>
        <v-checkbox v-model="alphaSender" label="AlphaSender"></v-checkbox>
        <div>
          <v-textarea v-model="smsMessage" hint="Message"></v-textarea>
        </div>
      </v-card-text>
      <div class="pa-5">Status</div>
      <div class="pa-5" v-for="msg in groupMessages" :key="msg.to">
        {{ msg.to }} - ({{ msg.status }})
      </div>
      <v-card-actions>
        <v-btn text color="deep-purple accent-4" @click="setGroupMessageData">
          setGroup
        </v-btn>
        <v-btn text color="deep-purple accent-4" @click="sendGroupMessage">
          Send
        </v-btn>
      </v-card-actions>
    </v-card>
  </hi-page>
</template>

<script>
import HiPage from "@/components/scaffold/HiPage";
import moment from "moment";
import { api } from "@/api";
import { db } from "@/db";
export default {
  name: "Tests",
  components: { HiPage },
  data() {
    return {
      smsNumber: null,
      smsNumber2: null,
      smsNumber3: null,
      smsMessage: "Hi {{name}},\n a Test message here...",
      smsTime: null,
      alphaSender: false,
      smsQueue: [],
      smsMessages: {},
      testGroupMessageData: {
        to: [
          //yana
          {
            type: "leads",
            uid: "VnxpXDzmPIqFLopEbK2w"
          },
          {
            type: "leads",
            uid: "B3A1Wzz6DP57mmg2SJDQ"
          },
          //phil
          {
            //invalid mobile number here
            type: "leads",
            uid: "2ayJEqA6AzP6m09U1Ms7"
          },
          //phil
          {
            type: "contacts",
            uid: "yPkBn82lMBGUSjhWKLxh"
          },
          //asif
          {
            type: "contacts",
            uid: "tpeb7FUIrJMZW4Owv0Cc"
          },
          //asif's dad
          {
            type: "contacts",
            uid: "s00Ca6Bd1kAO7IEp4eAR"
          }
        ],
        name: "Test Group Message"
      },
      testGroupId: "test-message-group",
      groupMessages: []
    };
  },
  firestore() {
    return {
      groupMessages: db
        .collection("sms/messages/outbox")
        .where("category", "==", "group")
        .where("tag", "==", this.testGroupId)
    };
  },
  methods: {
    async scheduleSms() {
      const time = moment().unix() + parseInt(this.smsTime);
      const result = await api.sms.schedule({
        to: this.smsNumber,
        body: this.smsMessage,
        time,
        tag: "Test",
        category: "Test"
      });
      console.log(result);
    },
    async sendSms() {
      const result = await api.sms.send(this.smsNumber, this.smsMessage, {
        tag: "Test",
        category: "Test",
        alphaSender: this.alphaSender
      });
      console.log(result);
    },
    async sendSmsBulk() {
      const result = await api.sms.sendBulk(
        [{ to: this.smsNumber }, { to: this.smsNumber2 }],
        this.smsMessage,
        {
          body: this.smsMessage,
          tag: "Test",
          category: "Test",
          alphaSender: this.alphaSender
        }
      );
      console.log(result);
    },
    async setGroupMessageData() {
      const colGroup = db.collection("sms/bulk/groups");
      await colGroup.doc(this.testGroupId).set({
        ...this.testGroupMessageData,
        alphaSender: this.alphaSender,
        body: this.smsMessage
      });
    },
    async sendGroupMessage() {
      console.log(await api.sms.sendGroupMessage(this.testGroupId));
    }
  }
};
</script>

<style scoped></style>
